import React from "react";

import styles from "./StatusChip.module.scss";

interface Props {
  label: string;
  isActive?: boolean;
  color?: string;
  onClick?: () => void;
  compact?: boolean;
}

export const StatusChip: React.FC<Props> = ({
  label,
  isActive,
  color,
  onClick,
  compact,
}) => {
  return (
    <button
      type="button"
      className={`${styles.Chip} ${compact ? styles.Compact : ""}`}
      data-active={isActive || undefined}
      onClick={onClick}
      style={isActive && color ? { color } : undefined}
    >
      <span
        className={styles.BgName}
        aria-hidden="true"
        style={isActive && color ? { color } : undefined}
      >
        {label}
      </span>
      <span
        className={styles.Label}
        style={isActive && color ? { color } : undefined}
      >
        {label}
      </span>
    </button>
  );
};
